module.exports = __webpack_public_path__ + "static/media/karta_hrv_regije.da1c8dc1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/karta_hrv_regije.png
 ** module id = 637
 ** module chunks = 0
 **/